<template>    
  <div class="results-table__cell">
    <div 
      class="snippet__status"
      :title="iconHint"
    >
      <svg class="snippet__status-icon" width="20" height="20">
        <use v-bind:xlink:href="cellIcon" />
      </svg>
<!-- -------------- Due to flex - absolute - overflow conflict --------------
      <div class="snippet__status-hint">
        {{ iconHint }}
      </div>
-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins], // 

  computed: {
    ...mapGetters([
      'statusIcon'
    ]),
    cellIcon() {
      return this.statusIcon(this.docData[this.cellData.dataFields[0]])
    },
    iconHint() {
      return this.docData[this.cellData.dataFields[1]]
    }
  }
};
</script>
